import $ from 'jquery';

/**
 * search results container module
 *
 * @module search-results-container
 * @version 0.1.0
 * @author hello@bradenericson.com
 *
 * Generated on 2017-09-21 using @14four/generator-excalibur 0.1.23
 * Converted to ES6 on 2023-12-02 using ChatGPT
 */

class SearchResultsContainer {
  constructor(element) {
    this.$el = $(element);
    this.setupDefaults();
    this.setupBinds();
    // Log removed: 'SearchResultsContainer : Initialized'
  }

  setupDefaults() {
    this.$searchInput = this.$el.find('.search');
  }

  setupBinds() {
    this.$searchInput.on('keyup', (e) => this.handleSearchKeyUp(e));
  }

  handleSearchKeyUp(e) {
    if (e.key === 'Enter') {
      const query = this.$searchInput.val().trim();
      if (query) {
        window.location = `/search?q=${encodeURIComponent(query)}`;
      }
    }
  }
}

export default SearchResultsContainer;
